import React from 'react';
import i18n from 'i18next';
import cs from 'classnames';
import _ from 'lodash';
import { parse } from 'date-fns';
import Select from 'react-select';
import { GE, LE } from '../tableFilters';
import DatePicker from '../../DatePicker';

export const TextFilter = (params) => {
  const { field, locFilters, handleChange } = params;
  const { property, title } = field;

  return (
    <input
      type="text"
      name={property}
      value={locFilters[property] || ''}
      onChange={(e) => handleChange(e.target)}
      placeholder={i18n.t(title)}
    />
  );
};

export const DropdownFilter = (params) => {
  const { field, locFilters, handleChange } = params;
  const { property, title, filter } = field;

  const options = filter.options.map(({ value, label }) => ({
    value,
    label: i18n.t(label),
  }));

  return (
    <Select
      options={options}
      onChange={({ value }) => {
        handleChange({ name: 'paymentMethodId', value });
      }}
      value={_.find(options, (opt) => opt.value === locFilters[property]) || ''}
      placeholder={i18n.t(title)}
      className={cs('customTableSelect', {
        lighter: !locFilters[property],
      })}
      isSearchable={false}
    />
  );
};

const getValidStartDate = (date) => (date ? parse(date, 'dd-MM-yyyy', new Date()) : null);

const getValidEndDate = (date) => (date ? parse(date, 'dd-MM-yyyy', new Date()) : null);

export const DateFilter = (params) => {
  const { field, locFilters, handleDateChange } = params;
  const { name, searchParamKey } = field;

  const val = _.has(locFilters, name)
    && parse(_.result(locFilters, `${name}.value`), 'dd-MM-yyyy', new Date());

  const placeholderText = `paymentTbl.filters.${name === GE ? 'from' : 'to'}`;

  return (
    <DatePicker
      date={val || null}
      name={name}
      onDateChange={(date) => handleDateChange({ name, date, searchParamKey })}
      minDate={
        name === GE
          ? null
          : getValidStartDate(_.result(locFilters, `${GE}.value`))
      }
      maxDate={
        name === GE
          ? getValidEndDate(_.result(locFilters, `${LE}.value`))
          : null
      }
      placeholderText={i18n.t(placeholderText)}
      dateInputProps={{ icon: 'calendar' }}
    />
  );
};
